import { apiClient } from './api';
import { Benefit, BenefitUsage } from '../types';

class BenefitService {
  // Admin APIs
  async getAllBenefits(): Promise<Benefit[]> {
    return apiClient.get<Benefit[]>('/admin/benefits');
  }

  async createBenefit(data: Partial<Benefit>): Promise<Benefit> {
    return apiClient.post<Benefit>('/admin/benefits', data);
  }

  async updateBenefit(id: string, data: Partial<Benefit>): Promise<Benefit> {
    return apiClient.patch<Benefit>(`/admin/benefits/${id}`, data);
  }

  // Member APIs
  async getMemberBenefits(): Promise<{ benefits: Benefit[]; usageHistory: BenefitUsage[] }> {
    return apiClient.get<{ benefits: Benefit[]; usageHistory: BenefitUsage[] }>('/member/benefits');
  }
}

export const benefitService = new BenefitService();
